import { useState, useMemo, useCallback } from "react"
import useParkEntities from "./useParkEntities"
import useLiveWaitTimes from "./useLiveWaitTimes"
import { loadSelections } from "../helpers/storage"

// The stored picks shared by the Wheel and Map pages, narrowed to entities the
// selected parks actually have and kept current by the live-refresh event, so
// the two pages can't disagree about what's visible.
//
// Note this fetches: useParkEntities hits /api/park_entities on mount to build
// the filter. Call this once per page rather than reaching for its pieces
// separately, or the page will issue the request twice.
const useRodgSelections = () => {
  const [items, setItems] = useState(loadSelections)
  const { entities: parkEntities, loading: entitiesLoading, filterByName } = useParkEntities()
  const visibleItems = useMemo(() => filterByName(items), [items, filterByName])

  useLiveWaitTimes(setItems)

  // Both pages drop a pick the same way once it's marked done.
  const removeItem = useCallback((name) => setItems((prev) => prev.filter((item) => item.name !== name)), [])

  return { items, removeItem, visibleItems, parkEntities, entitiesLoading, filterByName }
}

export default useRodgSelections
